import { Injectable } from '@angular/core';
import { BandwidthResult } from '../../models/app/bandwidth-result';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class BandwidthStore extends BaseStore<BandwidthResult> {}
